import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

interface LabelProps {
    label?: string,
    required?: boolean,
    secondary?: boolean,
    bold?: boolean,
    block?: boolean,
    style?: React.CSSProperties,
    className?: string,
}

class Label extends React.Component<LabelProps & WithStyles<typeof styles>, any> {

    //PM 2021-10-12
    //poprawka styli
    render() {
        const classes = this.props.classes;

        return (
            <label
                className={
                    classes.label
                    + (this.props.block ? '' : ` ${classes.floatLeft}`)
                    + (this.props.secondary ? ` ${classes.secondary}` : '')
                    + (this.props.bold ? ` ${classes.bold}` : '')
                    + (this.props.className ? ` ${this.props.className}` : '')
                }
                style={
                    this.props.block
                        ? { ...this.props.style, width: '' } : this.props.style && this.props.style.width
                            ? this.props.style : { ...this.props.style, width: '21%' }
                }
            >
                {this.props.label}
                {this.props.required &&
                    <span className={classes.error}>{" "}*</span>}
            </label>
        );
    }
}

const styles = (theme: Theme) => ({
    label: {
        //fontFamilly: "sans-serif",
        //fontSize: "small"
        fontSize: "12px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: theme.typography.body2.fontWeight,
        padding: "7px 0 4px",
        margin: 0
    },
    floatLeft: {
        float: "left" as "left"
    },
    secondary: {
        color: theme.palette.secondary.main
    },
    error: {
        color: theme.palette.error.main
    },
    bold: {
        fontWeight: 'bold' as 'bold'
    },
});

export default withStyles(styles)(Label);